/**
 * @generated SignedSource<<9ba9bf7f05db295c3587c1336b67eef6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditTabs_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditAccommodation_data" | "PackageEditDates_data" | "PackageEditMain_data" | "PackageEditTransport_data">;
  readonly " $fragmentType": "PackageEditTabs_data";
};
export type PackageEditTabs_data$key = {
  readonly " $data"?: PackageEditTabs_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTabs_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditTabs_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditMain_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditTransport_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditAccommodation_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditDates_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "8639dd6e06bf0895b8fb2d6fdf93e39f";

export default node;
